export default {
    contactUs: "contact Us",
    customServices: "Custom Services",
    FAQ: "FAQ",
    returnsAndExchange: "Returns & Exchange",
    shippingAndDelivery: "Shipping & Delivery",
    bikeRegistration: "Bike Registration",
    warranty: "Warranty",
    catalogues: "Catalogues",
    manualsUserAndGuides: "Manuals & User Guides",
    newsletterSignup: "Newsletter Signup",
    recycling: "Recycling",
    support: "Support",
    home: "home"
};
